import { createContext, useContext, useMemo } from "react";

/**
 * @typedef {{
 *   workshop: import("../../../api/workshop").WorkshopStepInfo,
 *   spark: import("../../../api/spark").WorkshopStepSpark,
 *   settings: import("../../../api/workshop").WorkshopSettings,
 *   structure: import("../../../api/spark").WorkshopStepSpark["structure"],
 * }} SparkContextValue
 */

/** @type {import("react").Context<SparkContextValue | null>} */
const SparkContext = createContext(null);

export const SparkProvider = ({
  workshop,
  spark,
  settings,
  structure,
  children,
}) => {
  const value = useMemo(
    () => ({
      workshop,
      spark,
      settings,
      structure,
    }),
    [workshop, structure, settings, spark],
  );

  return (
    <SparkContext.Provider value={value}>{children}</SparkContext.Provider>
  );
};

export const useSparkContext = () => {
  const context = useContext(SparkContext);
  if (!context) throw new Error("useSpark must be used within a SparkProvider");
  return context;
};
